import {Empty, Timeline, TimelineItemProps} from 'antd'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import {EventResponseDTO } from '../../model/ResponsesDTO';
import { ProviderValue, useAxios } from '../../config/axios-config';
import { PageLoader } from '../util/PageLoader';
import { ErrorPage } from '../error/ErrorPage';
import {LocalDateTime} from "local-date";


export const EventPopover : React.FC<{customerId : number,
    showEvents : boolean,
    setShowEvents: Dispatch<SetStateAction<boolean>>}> = (props) => {

    const axiosInstance = useAxios() as ProviderValue
    const {customerId, showEvents, setShowEvents} = props
    const [historyEvents, setHistoryEvents] = useState<TimelineItemProps[]>([])
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)
    const [fetchedAll, setFetchedAll] = useState<boolean>(false)
    const [page, setPage] = useState<number>(0)
    const controller = new AbortController();
    const signal = controller.signal

    useEffect(() => {
        if (showEvents) {
            setFetchedAll(false)
            handleHistoryEvents(0)
        }
        // eslint-disable-next-line
    },[showEvents])

    const handleDate = (date : LocalDateTime) : string => {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    }

    const handleHistoryEvents = async (page : number) => {
        setIsLoaded(false)
        setIsError(false)
        await axiosInstance.get<EventResponseDTO>(`/events/secure/fetch/forcustomer/${customerId}/${page}`,
            {signal}).then((response) => {

            let items : any[] = response.data.events
                .map(event => (
                    {
                        label: handleDate(event.eventDate),
                        children: `${event.userName} | ${event.description}`,
                        color: '#55B1B4',
                        order: event.eventDate
                    }
                ))

            if (items !== undefined) {
                setHistoryEvents([...historyEvents,...items].sort((a,b) => dayjs(b.order! as number)
                    .diff(dayjs(a.order! as number))) as TimelineItemProps[])
                if (items.length < 10) {
                    setFetchedAll(true)
                }
            } else {
                setHistoryEvents([])
                setFetchedAll(true)
            }
            setPage(prevState => prevState + 1)
            setIsLoaded(true)
        }).catch((e) => {
            setIsLoaded(true)
            setIsError(true)
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })

    }

    const handleClose = () => {
        setShowEvents(false)
        setFetchedAll(false)
        setHistoryEvents([])
        setPage(0)
    }
    const handleMore = () => {
        handleHistoryEvents(page)
    }

    return (
        <Dialog fullWidth onClose={() => setShowEvents(false)} open={showEvents} scroll={'paper'}>
            <DialogTitle id="dialog-title">
                {"Historia zgłaszania i odwoływania posiłków"}
            </DialogTitle>
            <DialogContent>
                {!isLoaded ?
                    isError ?
                        <ErrorPage />
                        :
                        <PageLoader />
                    :
                    historyEvents.length === 0 ?
                        <Empty />
                        :
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'}}>
                        <Timeline className="mt-3 mb-0" mode='left' items={historyEvents}/>
                        <button disabled={fetchedAll} className='button-65-mobile' onClick={() => handleMore()}>
                            Więcej
                        </button>
                        </div>
                }

            </DialogContent>
            <DialogActions>
                <button className='button-65' onClick={() => handleClose()}>
                    Zamknij
                </button>
            </DialogActions>
        </Dialog>
    )
}